import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import excelImg from "../../Assets/images/excel.svg";
import useMakeRequest from "../../utils/ApiHelper";
import { useNavigate } from "react-router-dom";
import { ApiConstants } from "../../constants/ApiConstants";
import { saveToStorage } from "../../utils/Helper";
import { Modal } from "react-bootstrap";
import NewAddress from "../../Modal/NewAddress";
import { toast } from "react-toastify";
import { ApiTypes } from "../../constants/Constants";
import FrontLoader from "../layout/FrontLoader";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { socket } from "../../utils/Socket";
import * as XLSX from 'xlsx';
import ExcelSheet from "../../Modal/ExcelSheet";



function ExcelSelect() {
    const addressList = useMakeRequest()
    const xlsxPreview = useMakeRequest()
    const shippingList = useMakeRequest()
    const Add = useMakeRequest()
    const [show, setShow] = useState(false)
    const [data, setData] = useState<any>({})
    const [error, setError] = useState<any>({})
    const [file, setFile] = useState('')
    const [fileName, setFileName] = useState('')
    const navigate = useNavigate()
    const [showPreview, setShowPreview] = useState(false)
    const [excelUrl, setExcelUrl] = useState('')



    useEffect(() => {
        addressList.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false })
        shippingList.makeRequest({ url: ApiConstants?.ShippingList, toastStatus: false })
    }, [show])


    const handleInputValues = (e: any) => {
        const { name, value } = e.target
        setData((data: any) => ({ ...data, [name]: value }))
    }

    const handleClose = () => {
        setShow(false)
    }

    const handleNextPage = () => {
        const errobj: any = {}
        if (!data?.shipping_id) {
            errobj.shipping = LanguageConstants?.PLEASE_SELECT_SHIPPING_TYPE
        }
        if (!data?.address_id) {
            errobj.address = LanguageConstants?.PLEASE_SELECR_DELIVER_ADDRESS
        }
        if (!file) {
            errobj.file = LanguageConstants?.SELECT_EXCEL
        }
        if (Object.keys(errobj).length > 0) {
            setError(errobj)
        } else {
            const payload = {
                shipping_id: data?.shipping_id,
                address_id: data?.address_id,
                excel_file: file
            }
            Add.makeRequest({ payload, type: ApiTypes.POSTAPIFORMDATA, url: ApiConstants?.QuotesAddExcel, toastStatus: true })
        }

    }

    const selectFileHandler = (e: any) => {
        const getExtension = e?.target?.files[0]?.name.split('.').pop().toLowerCase();
        // console.log(e?.target?.files[0]?.name , "===============>>>>")
        if (getExtension === 'xlsx') {
            setFileName(e?.target?.files[0]?.name)
            e.preventDefault();
            let files;
            if (e.dataTransfer) {
                files = e.dataTransfer.files;
                setExcelUrl('')
            } else if (e.target) {
                files = e.target.files;
                setExcelUrl('')
            }
            setFile(files[0]);
        } else {
                setExcelUrl('')
            e.preventDefault();
            toast.error("Please upload a valid .xlsx file");
            return;
        }
    };

    useEffect(() => {
        if (Add?.status) {
            const payload = {
                sender_type: "1",
                receiver_id: '1'
            }
            socket.emit('admin_count', payload, async (Response: any) => {
            })

            if (Add?.data?.data?.inCorrectData?.length >= 1) {
                navigate('/incorrect-excel', { state: { data: Add?.data?.data?.inCorrectData } })
            } else {
                navigate('/my-quotation')
            }
        }
    }, [Add?.status])

    const handlePreview = async () => {
        if (excelUrl) {
            setShowPreview(true)
            return
        }
        if (file) {
            const payload = {
                file_path: file
            }
            xlsxPreview.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesXlxsPreview, toastStatus: false })
            setExcelUrl('')
        } else {
            toast.error("Please upload a file first")
        }
    }

    const handelXlsxClose = () => {
        setShowPreview(false)
    }

    useEffect(() => {
        if (xlsxPreview?.status) {
            setShowPreview(true)
            setExcelUrl(xlsxPreview?.data?.file_path)
        }
    }, [xlsxPreview?.status])



    return (
        <>
            {Add?.loading || xlsxPreview?.loading ? <FrontLoader /> : null}
            <main>
                {/* top banner section start */}
                <section
                    className="main-banner small-banner"
                    style={{ background: `url(${profileBanner}) center/cover` }}
                >
                    <div className="container">
                        <h1 className="small-banner-heading">{LanguageConstants?.REQUESTQUOTES}</h1>
                    </div>
                </section>
                {/* top banner section end  */}

                <div className="footer-space">
                    <div className="container">
                        <h2 className="title-1 mb-2">{LanguageConstants?.BULKREQUEST} {LanguageConstants?.EXCEL}</h2>
                        <p className="title-para">
                            {LanguageConstants?.BULK_PERA}
                        </p>
                        <div className="card-box">
                            <div className="row">
                                <div className="col-md-5 col-lg-4">
                                    <div className="com-input-wrap">
                                        <label className="form-label">
                                            {LanguageConstants?.DELIVERYADDRESS}{" "}
                                            <span className="input-star">*</span>
                                        </label>
                                        <select
                                            className="form-select"
                                            aria-label="Default select example"
                                            name="address_id"
                                            onChange={handleInputValues}
                                        >
                                            <option selected value={''} >{LanguageConstants?.DELIVERYADDRESS}</option>
                                            {addressList?.data?.data?.rows?.map((res: any, i: any) => (
                                                <option value={res?.id} key={i}>{res?.street_line}</option>
                                            ))}
                                        </select>
                                        <p style={{ color: 'red' }}>{error?.address}</p>
                                    </div>
                                </div>
                                <div className="col-auto mx-auto m-md-0">
                                    {/* <button className="input-add-btn">
                            <i className="icon-add-circle"></i>
                            </button> */}
                                </div>
                                <div className="col-md-5 col-lg-4">
                                    <div className="com-input-wrap">
                                        <label className="form-label">
                                            {LanguageConstants?.SHIPPINGMETHOD} <span className="input-star">*</span>
                                        </label>
                                        <select
                                            className="form-select"
                                            aria-label="Default select example"
                                            name="shipping_id"
                                            onChange={handleInputValues}
                                        >
                                            <option selected value={''}>{LanguageConstants?.SHIPPINGMETHOD}</option>
                                            {shippingList?.data?.data?.map((resp: any, i: any) => (
                                                <option value={resp?.id} key={i}>{resp?.shipping_details?.name}</option>
                                            ))}

                                        </select>
                                        <p style={{ color: 'red' }}>{error?.shipping}</p>
                                    </div>
                                </div>
                                <div className="col-md-5 col-lg-3 ms-0 ms-lg-auto ps-3 ps-lg-0 mt-3 mt-lg-0 add-address-btn mb-0 mb-lg-3"   >
                                    <div className="add-new-address com-input-wrap" onClick={() => setShow(true)}>
                                            <div className="add-txt cursor-pointer h-auto mb-3 justify-content-start">+{LanguageConstants?.NEWADDRES}</div>
                                        {/* <label className="form-label d-none d-lg-block">

                                        </label> */}
                                    </div>
                                    <div className="row">
                                        <div className="col-xxl-10">
                                            <a href={'assets/docs/RcParts.xlsx'} download>
                                                <button className="excel-btn excel-btn-sm">
                                                    <img className="excel-img" src={excelImg} alt="" />
                                                    <span className="excel-txt">
                                                        {LanguageConstants?.Download} <br />
                                                        {LanguageConstants?.TEMPLATE}
                                                    </span>
                                                    <span className="excel-icon">
                                                        <i className="icon-download"></i>
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row gy-3 mt-4 align-items-start">
                                <div className="col-md-5 col-lg-4">
                                     <label htmlFor="uploadExcelFile" className="excel-btn excel-btn-blue cursor-pointer">
                                        <img className="excel-img" src={excelImg} alt="" />
                                        <span className="excel-txt">{fileName ? fileName : LanguageConstants?.UploadExcel}</span>
                                        <span className="excel-icon">
                                            <i className="icon-upload-2"></i>
                                        </span>
                                    </label>
                                    <input type="file" className="d-none" id="uploadExcelFile" onChange={selectFileHandler} />
                                    <p style={{ color: 'red' }} className="mb-0">{error?.file}</p>
                                    {file != '' ?
                                            <div className="preview-txt cursor-pointer" onClick={() => handlePreview()}><i className="icon-eye-open"></i> {LanguageConstants?.SEEPREVIEW}</div>
                                       
                                    : null}
                                </div>
                                <div className="col-auto mx-auto m-md-0"></div>
                                <div className="col-md-5 col-lg-3 flex-center ps-3 ps-lg-0">
                                    <button className="round-btn w-100 excel-submit-btn mt-2 mt-xl-3" onClick={() => handleNextPage()} >
                                        {LanguageConstants?.EXCLSUBMIT}
                                    </button>
                                </div>
                                <div className="col-auto d-none d-md-block">
                                    <button className="input-add-btn hidden-ct">
                                        <i className="icon-add-circle"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Modal show={show}>
                <NewAddress handleClose={handleClose} />
            </Modal>

            {/* //xlsxPreview?.status  */}
            <Modal show={showPreview} >
                <ExcelSheet data={excelUrl} handleClose={handelXlsxClose} fileName={fileName} />
            </Modal>


        </>
    )
}

export default ExcelSelect